import { MainserviceService } from './../mainservice.service';
import { AuthService } from "../services/auth.service";
import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { LocationStrategy, PlatformLocation, Location, DatePipe } from '@angular/common';
import { LegendItem, ChartType } from '../lbd/lbd-chart/lbd-chart.component';
import * as Chartist from 'chartist';

// import moment  from 'moment'
// import moment from 'moment/src/moment';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})

export class HomeComponent implements OnInit {
 
  usertype = localStorage.getItem('USER-TYPE')
  shopid = JSON.parse(localStorage.getItem('USER')).info.id
  shopstats :any;
  clues:any;
  mall:any;
  promocode:any;
  allstats: any;
  leaders:any;

  public shopChartType: ChartType;
  public shopChartData: any;
  public shopChartLegendItems: LegendItem[];

  public mallChartType: ChartType;
  public mallChartData: any;
  public mallChartLegendItems: LegendItem[];

  public gameChartType: ChartType;
  public gameChartData: any;
  public gameChartLegendItems: LegendItem[];

  
  public activityChartType: ChartType;
  public activityChartData: any;
  public activityChartOptions: any;
  public activityChartResponsive: any[];
  public activityChartLegendItems: LegendItem[];

  public joinActivityChartType: ChartType;
  public joinActivityChartData: any;
  public joinActivityChartOptions: any;
  public joinActivityChartResponsive: any[];
  public joinActivityChartLegendItems: LegendItem[];

  public promoChartType: ChartType;
  public promoChartData: any;
  public promoChartLegendItems: LegendItem[];

  public hoursChartType: ChartType;
  public hoursChartData: any;
  public hoursChartOptions: any;
  public hoursChartResponsive: any[];
  public hoursChartLegendItems: LegendItem[];

  public shophoursChartType: ChartType;
  public shophoursChartData: any;
  public shophoursChartOptions: any;
  public shophoursChartResponsive: any[];
  public shophoursChartLegendItems: LegendItem[];

  constructor(
    private mainServ: MainserviceService,
    private authservice:AuthService,
    private router:Router
  ) {

  }

  ngOnInit() {
    if (this.usertype === 'shop') {
          this.getShopStats()
          this.getClueStats()
          this.getShopUserPlaybehaviour() 

          this.shophoursChartOptions = {
            low: 0,
            high: 5,
            showArea: true,
            height: '245px',
            axisX: {
              showGrid: true,
            },
            lineSmooth: Chartist.Interpolation.simple({
              divisor: 3
            }),
            showLine: true,
            showPoint: true,
          };
          this.shophoursChartResponsive = [
            ['screen and (max-width: 640px)', {
              axisX: {
                labelInterpolationFnc: function (value) {
                  return value[0];
                }
              }
            }]
          ];
          this.shophoursChartLegendItems = [
            { title: 'Correct Answers', imageClass: 'fa fa-circle text-info' },
            { title: 'Wrong Answers', imageClass: 'fa fa-circle text-danger' },
          ];
      
    }if (this.usertype === 'mall') {
        
        this.getallstats() 
        this.getPromocodeStats()
    } if (this.usertype === 'admin') {
          this.getallstats() 
          this.getUserPlaybehaviour()  
          this.getPromocodeStats()
          this.getLeaderboard()
          this.getUserJoin()

          this.hoursChartOptions = {
            low: 0,
            high: 60,
            showArea: true,
            height: '245px',
            axisX: {
              showGrid: true,
            },
            lineSmooth: Chartist.Interpolation.simple({
              divisor: 2
            }),
            showLine: true,
            showPoint: true,
          };
          this.hoursChartResponsive = [
            ['screen and (max-width: 640px)', {
              axisX: {
                labelInterpolationFnc: function (value) {
                  return value[10];
                }
              }
            }]
          ];
          this.hoursChartLegendItems = [
            { title: 'Correct Answers', imageClass: 'fa fa-circle text-info' },
            { title: 'Wrong Answers', imageClass: 'fa fa-circle text-danger' },
          ];


     }
     
     this.getActivationStats()
 
     this.promoChartType = ChartType.Pie;
     this.promoChartData = {
       labels: ['100', '30', '30', '40'],
       series: [100, 30, 30, 40]
     };
 

     this.joinActivityChartOptions = {
       low: 0,
       high: 20,
       seriesBarDistance: 20,
       axisY:{
        labelInterpolationFnc: function(value) {
          return ( value % 1 === 0 ) ? value : '';
          }
       },
       axisX: {
         showGrid: true
       },
       height: '245px'
     };
     this.joinActivityChartResponsive = [
       ['screen and (max-width: 640px)', {
         seriesBarDistance: 1,
         axisX: {
           labelInterpolationFnc: function (value) {
             return value[0];
           }
         }
       }]
     ];
     this.joinActivityChartLegendItems = [
       { title: 'User  Sign Ups', imageClass: 'fa fa-circle text-danger' }
     ];

     ///
     this.activityChartOptions = {
      seriesBarDistance: 20,
      axisX: {
        showGrid: true
      },
      
      height: '245px'
    };
    this.activityChartResponsive = [
      ['screen and (max-width: 640px)', {
        seriesBarDistance: 5,
        axisX: {
          labelInterpolationFnc: function (value) {
            return value[0];
          }
        }
      }]
    ];
    this.activityChartLegendItems = [
      { title: 'Activated Users', imageClass: 'fa fa-circle text-info' },
      // { title: 'Active Users', imageClass: 'fa fa-circle text-danger' }
    ];
  }




//SHOP AREA
   getShopStats(){
     this.mainServ.getShopPromoStats(this.shopid).subscribe( data =>{
        this.shopstats = data[0]
    
    //SHOP PIE CHART
   this.shopChartType = ChartType.Pie;
   this.shopChartData = {
     labels: [`${this.shopstats.redeemed} Redeemed`, `${this.shopstats.expired} Expired`, `${this.shopstats.unused} Unused`],
     series: [this.shopstats.redeemed, this.shopstats.expired, this.shopstats.unused]
   };
   this.shopChartLegendItems = [
     { title: 'Expired', imageClass: 'fa fa-circle text-danger' },
     { title: 'Unused', imageClass: 'fa fa-circle text-warning' },
     { title: 'redeemed', imageClass: 'fa fa-circle text-primary' }
   ];
   })

   }
   getClueStats(){
     this.mainServ.getClueStats(this.shopid).subscribe(data =>{
       this.clues =data[0]
     })
   }
   getShopUserPlaybehaviour() {
    this.mainServ.getShopClueStats(this.shopid).subscribe(data => {
      var labels = []
      var series1 = []
      var series2 = []

      for (var i in data) {
        var dt = data[i]

        labels.push(dt.value)
        series1.push(dt.wrong)
        series2.push(dt.correct)

      }
      this.shophoursChartType = ChartType.Line;
      this.shophoursChartData = {
        labels: labels,
        series: [
          series2,
          series1
        ]
      }
    });
  }




  //THE GAME ADMIN
  //ALL STATS
  getPromocodeStats(){
    this.mainServ.getStatistics("promocodes", "all").subscribe(data => {
      var labels = []
      var series1= []
      for (var i in data) {
        var dt = data[i]
       this.promocode =dt
      }
    //GAME PIE CHART
   this.gameChartType = ChartType.Pie;
   this.gameChartData = {
     labels: [`${this.promocode.redeemed} Redeemed`, `${this.promocode.expired} Expired`, `${this.promocode.unused} Unused`],
     series: [0, 0, 0]
   };
   this.gameChartLegendItems = [
     { title: 'Expired', imageClass: 'fa fa-circle text-danger' },
     { title: 'Unused', imageClass: 'fa fa-circle text-warning' },
     { title: 'redeemed', imageClass: 'fa fa-circle text-primary' }
   ];
    })
  }

  getallstats() {
    this.mainServ.getAllStatistics().subscribe(data => {
      this.allstats = data
    }, error => {
      console.log(error)
    })
  }
 

  getUserPlaybehaviour() {
    this.mainServ.getStatistics("plays", "daily").subscribe(data => {
      var labels = []
      var series1 = []
      var series2 = []
      
      function compare(a,b){
        let comparison = 0;
        if(a.value > b.value){
          comparison =1;
        }else if(a.value < b.value){
          comparison =-1;
        }
        return comparison;
      }
            
      data.sort(compare);
      
      for (var i in data) {
        var dt = data[i]
      
        //labels.push(dt.value.slice(5,10))
        //series2.push(dt.wrong)
        //series1.push(dt.correct)
        

      }

      let s:number;
      let to = data.length;
      let from = to-7;
      for( s=from; s<to; s++ ){
        var nDt = data[s]
        labels.push(nDt.value.slice(5,10))
        series2.push(nDt.wrong)
        series1.push(nDt.correct)
      }
 

      this.hoursChartType = ChartType.Line;
      this.hoursChartData = {
        labels: labels,
        series: [
          series2,
          series1
        ]
      }
    });
  }

  getActivationStats() {
    this.mainServ.getStatistics("activations", "daily").subscribe(data => {
      var labels = []
      var series = []

      for(var i in data){
        var dat=data[i]
        labels.push(dat.value)
        series.push(dat.count)

      }
      this.activityChartType = ChartType.Bar;
      this.activityChartData = {
        labels: labels,
        series: [
          series,
        ]
      };
    })
  }

  getUserJoin(){
    this.mainServ.getStatistics("users","daily").subscribe(data =>{
      var labels = []
      var series = []

      function compare(a,b){
        let comparison = 0;
        if(a.value > b.value){
          comparison =1;
        }else if(a.value < b.value){
          comparison =-1;
        }
        return comparison;
      }
      data.results.sort(compare);

      let s:number;
      let to = data.results.length;
      let from = to-7;

      for( s=from; s<to; s++ ){
        var nDt = data.results[s]
        labels.push(nDt.value.slice(5,10))
        series.push(nDt.users)
      }

      for(var i in data.results){
        //var dat=data.results[i]
        //labels.push(dat.value)
        //series.push(dat.users)
        
      }
      this.joinActivityChartType = ChartType.Bar;
      this.joinActivityChartData = {
        labels: labels,
        series: [
          series,
        ]
      };
    })
  }
  
  getLeaderboard(){
    this.mainServ.getLeaderboard().subscribe( 
      data => this.leaders = data
    )
  }




  ngAfterViewInit() {

  }

}




// WEBPACK FOOTER //
// D:/PROJECTS/Sokousoni/winda-dashboard/dashboard-winda-mvp/src/app/home/home.component.ts